import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createInitialColumnSortState } from './columnSort.types'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerColumnSortByBoardId = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return {}
  return state.taskTracker.columnSort[boardId] ?? {}
}

export const selectTaskTrackerColumnSort = (
  state: AppState,
  boardId: number | null,
  columnId: number,
) => {
  if (boardId == null) return createInitialColumnSortState()
  return (
    state.taskTracker.columnSort[boardId]?.[columnId] ??
    createInitialColumnSortState()
  )
}
